/**
 * Datová struktura zásobník
 */
export class Stack<T> {
    protected _internalStack: Array<T> = [];

    public length(): number {
        return this._internalStack.length;
    }

    public isEmpty(): boolean {
        return this._internalStack.length === 0;
    }

    public push(item: T): void {
        this._internalStack.push(item);
    }

    public pop(): T | undefined {
        return this._internalStack.pop();
    }

    public peek(): T | null {
        return this._internalStack.length > 0 ? this._internalStack[this._internalStack.length - 1] : null;
    }
}
